"use client";

import type { ReactNode, SVGProps } from "react";

import { MarqueeTrack } from "@/components/blocks/marquee-track";
import { cn } from "@/lib/utils";

/** Figma chip icon "Sell" (Marketing), peach (node 6142:29398). */
function IconSell(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 15 15" fill="none" aria-hidden {...props}>
      <g clipPath="url(#chip-sell-clip)">
        <path
          d="M12.8896 6.85465L7.56307 1.52581C7.33988 1.30251 7.03223 1.17578 6.71252 1.17578H2.38737C1.72381 1.17578 1.18091 1.71893 1.18091 2.38277V6.70981C1.18091 7.02967 1.30759 7.33745 1.53681 7.56074L6.86333 12.8896C7.33384 13.3603 8.09995 13.3603 8.57046 12.8896L12.8956 8.56254C13.3661 8.09181 13.3661 7.33141 12.8896 6.85465ZM7.71388 12.0387L2.38737 6.70981V2.38277H6.71252L12.039 7.71161L7.71388 12.0387Z"
          fill="#FFCDB5"
        />
        <path
          d="M3.89557 4.80169C4.3953 4.80169 4.80041 4.3964 4.80041 3.89645C4.80041 3.3965 4.3953 2.99121 3.89557 2.99121C3.39583 2.99121 2.99072 3.3965 2.99072 3.89645C2.99072 4.3964 3.39583 4.80169 3.89557 4.80169Z"
          fill="#FFCDB5"
        />
      </g>
      <defs>
        <clipPath id="chip-sell-clip">
          <rect width="14.1783" height="14.1783" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

/** Figma chip icon "Data table" (Inventory), green (node 6142:29408). */
function IconDataTable(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 13 13" fill="none" aria-hidden {...props}>
      <path
        d="M2.51363 10.5609C2.2371 10.5609 2.00037 10.4624 1.80344 10.2655C1.60652 10.0686 1.50806 9.83184 1.50806 9.55531V2.51631C1.50806 2.23978 1.60652 2.00305 1.80344 1.80613C2.00037 1.6092 2.2371 1.51074 2.51363 1.51074H9.55262C9.82915 1.51074 10.0659 1.6092 10.2628 1.80613C10.4597 2.00305 10.5582 2.23978 10.5582 2.51631V9.55531C10.5582 9.83184 10.4597 10.0686 10.2628 10.2655C10.0659 10.4624 9.82915 10.5609 9.55262 10.5609H2.51363ZM2.51363 4.18807H9.55262V2.51631H2.51363V4.18807ZM2.51363 6.87798H9.55262V5.19365H2.51363V6.87798ZM2.51363 9.55531H9.55262V7.88355H2.51363V9.55531ZM3.01641 3.84869V2.84312H4.02198V3.84869H3.01641ZM3.01641 6.5386V5.53303H4.02198V6.5386H3.01641ZM3.01641 9.2285V8.22293H4.02198V9.2285H3.01641Z"
        fill="#A9EDB5"
      />
    </svg>
  );
}

/** Figma chip icon "Home work" (Rent), blue (node 6142:29413). */
function IconHomeWork(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 13 13" fill="none" aria-hidden {...props}>
      <g clipPath="url(#chip-homework-clip)">
        <path
          d="M0.501953 5.53541V10.5633H3.51866V8.04934H4.52424V10.5633H7.54095V5.53541L4.02145 3.02148L0.501953 5.53541ZM6.53538 9.55769H5.52981V7.04377H2.51309V9.55769H1.50752V6.05328L4.02145 4.25834L6.53538 6.05328V9.55769Z"
          fill="#C6DAFF"
        />
        <path
          d="M9.55171 3.52148H8.54614V4.52705H9.55171V3.52148Z"
          fill="#C6DAFF"
        />
        <path
          d="M9.55171 5.53711H8.54614V6.54268H9.55171V5.53711Z"
          fill="#C6DAFF"
        />
        <path
          d="M9.55171 7.54492H8.54614V8.55049H9.55171V7.54492Z"
          fill="#C6DAFF"
        />
        <path
          d="M5.02673 1.5127V2.50318L6.0323 3.22217V2.51827H10.5574V9.55726H8.54623V10.5628H11.5629V1.5127H5.02673Z"
          fill="#C6DAFF"
        />
      </g>
      <defs>
        <clipPath id="chip-homework-clip">
          <rect width="12.0668" height="12.0668" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

/** Figma chip icon "Add circle" (Other/Additional), blue (node 6142:29442). */
function IconAddCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 15 15" fill="none" aria-hidden {...props}>
      <path
        d="M7.21975 1.20508C3.8985 1.20508 1.203 3.90058 1.203 7.22182C1.203 10.5431 3.8985 13.2386 7.21975 13.2386C10.541 13.2386 13.2365 10.5431 13.2365 7.22182C13.2365 3.90058 10.541 1.20508 7.21975 1.20508ZM10.2281 7.8235H7.82142V10.2302H6.61807V7.8235H4.21138V6.62015H6.61807V4.21345H7.82142V6.62015H10.2281V7.8235Z"
        fill="#C6DAFF"
      />
    </svg>
  );
}

/** Figma chip icon "Account tree" (Operations), magenta (node 6142:29437). */
function IconAccountTree(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 13 13" fill="none" aria-hidden {...props}>
      <path
        d="M7.50746 10.4607V8.98598H5.54115V4.0702H4.55799V5.54493H1.11694V1.6123H4.55799V3.08704H7.50746V1.6123H10.9485V5.54493H7.50746V4.0702H6.5243V8.00282H7.50746V6.52809H10.9485V10.4607H7.50746ZM8.49062 4.56177H9.96535V2.59546H8.49062V4.56177ZM8.49062 9.47756H9.96535V7.51124H8.49062V9.47756ZM2.1001 4.56177H3.57483V2.59546H2.1001V4.56177Z"
        fill="#FFC1FD"
      />
    </svg>
  );
}

/** Figma chip icon "Stacked bar chart" (Growth), green (node 6142:29449). */
function IconStackedBar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
      <path d="M10.6666 6H13.3333V13.3333H10.6666V6Z" fill="#90E7A0" />
      <path
        d="M10.6666 2.66699H13.3333V5.33366H10.6666V2.66699Z"
        fill="#90E7A0"
      />
      <path
        d="M6.66659 4.66699H9.33325V7.33366H6.66659V4.66699Z"
        fill="#90E7A0"
      />
      <path
        d="M2.66659 6.66699H5.33325V9.33366H2.66659V6.66699Z"
        fill="#90E7A0"
      />
      <path d="M2.66659 10H5.33325V13.3333H2.66659V10Z" fill="#90E7A0" />
      <path d="M6.66659 8H9.33325V13.3333H6.66659V8Z" fill="#90E7A0" />
    </svg>
  );
}

/** Figma chip icon "People" (Hiring), teal (node 6142:29430). */
function IconPeople(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3.3 3.3 14.8 14.8" fill="none" aria-hidden {...props}>
      <path
        d="M14.7848 12.3098C13.6982 11.7535 12.2883 11.3008 10.652 11.3008C9.01562 11.3008 7.60566 11.7535 6.51909 12.3098C5.87231 12.6396 5.47778 13.3058 5.47778 14.0302V15.8282H15.8261V14.0302C15.8261 13.3058 15.4316 12.6396 14.7848 12.3098ZM14.5326 14.5347H6.77133V14.0302C6.77133 13.7844 6.90068 13.5645 7.10765 13.461C7.87731 13.0665 9.11911 12.5943 10.652 12.5943C12.1848 12.5943 13.4266 13.0665 14.1963 13.461C14.4032 13.5645 14.5326 13.7844 14.5326 14.0302V14.5347Z"
        fill="#B6E9DC"
      />
      <path
        d="M9.21604 10.6586H12.0877C12.8703 10.6586 13.4718 9.97302 13.3683 9.19689L13.1614 7.61228C12.9609 6.3834 11.8937 5.48438 10.6519 5.48438C9.41008 5.48438 8.3429 6.3834 8.1424 7.61228L7.93544 9.19689C7.83195 9.97302 8.43345 10.6586 9.21604 10.6586ZM9.42301 7.80631C9.5265 7.21128 10.0439 6.77793 10.6519 6.77793C11.2598 6.77793 11.7773 7.21128 11.8807 7.80631L12.0877 9.36505H9.21604L9.42301 7.80631Z"
        fill="#B6E9DC"
      />
    </svg>
  );
}

/** Figma chip icon "Ads click" (Advertising), peach (node 6142:29468). */
function IconAdsClick(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
      <path
        d="M7.80667 11.9933C5.68667 11.8933 4 10.1467 4 8C4 5.79333 5.79333 4 8 4C10.1467 4 11.8933 5.68667 11.9933 7.80667L10.5933 7.38667C10.32 6.20667 9.26 5.33333 8 5.33333C6.52667 5.33333 5.33333 6.52667 5.33333 8C5.33333 9.26 6.20667 10.32 7.38667 10.5933L7.80667 11.9933ZM14.6667 8C14.6667 8.2 14.66 8.4 14.64 8.6L13.3267 8.20667C13.3333 8.14 13.3333 8.06667 13.3333 8C13.3333 5.05333 10.9467 2.66667 8 2.66667C5.05333 2.66667 2.66667 5.05333 2.66667 8C2.66667 10.9467 5.05333 13.3333 8 13.3333C8.06667 13.3333 8.14 13.3333 8.20667 13.3267L8.6 14.64C8.4 14.66 8.2 14.6667 8 14.6667C4.32 14.6667 1.33333 11.68 1.33333 8C1.33333 4.32 4.32 1.33333 8 1.33333C11.68 1.33333 14.6667 4.32 14.6667 8ZM12.1533 10.84L14.6667 10L8 8L10 14.6667L10.84 12.1533L13.6867 15L15.0067 13.68L12.1533 10.84Z"
        fill="#FFCDB5"
      />
    </svg>
  );
}

interface SpendChipProps {
  label: string;
  icon: ReactNode;
  bg: string;
  border: string;
}

interface SpendChipRow {
  chips: SpendChipProps[];
  animationClassName: string;
  /** Offset from the chip fade container top. */
  className: string;
  trackClassName: string;
  /** Mirror the RTL track so chips scroll left-to-right. */
  mirror?: boolean;
}

/** Shared chip area — rows sit inside this container (Figma 5948:28542). */
const SPEND_CHIPS_AREA_CLASS =
  "top-[99.5px] lg:top-[118.22px] h-[calc(100%-99.5px)] lg:h-[calc(100%-118.22px)]";
const SPEND_CHIPS_FILL_CLASS = "absolute inset-0";

const SPEND_CHIP_ROWS: SpendChipRow[] = [
  {
    // Row 1 (Marketing/Inventory/Rent) — mobile 6147:28798 / desktop 6142:29395.
    animationClassName:
      "motion-safe:animate-[values-marquee_40s_linear_infinite]",
    className: "top-0",
    trackClassName: "gap-[16.535px] lg:gap-5",
    chips: [
      {
        label: "Marketing",
        icon: <IconSell className="size-[14px]" />,
        bg: "bg-[#fef2f2]",
        border: "border-[#ffcdb5]",
      },
      {
        label: "Inventory",
        icon: <IconDataTable className="size-3" />,
        bg: "bg-[#eafaee]",
        border: "border-[#abf0b7]",
      },
      {
        label: "Rent",
        icon: <IconHomeWork className="size-3" />,
        bg: "bg-[#f0f5ff]",
        border: "border-[#c6daff]",
      },
    ],
  },
  {
    // Row 2 (Other/Hiring/Operations/Additional) — mobile 6147:28825 / desktop 6142:29422.
    animationClassName:
      "motion-safe:animate-[values-marquee_45s_linear_infinite]",
    mirror: true,
    className: "top-[58.97px] lg:top-[53.81px]",
    trackClassName: "gap-[14.985px] lg:gap-[18px]",
    chips: [
      {
        label: "Other",
        icon: <IconAddCircle className="size-[14px]" />,
        bg: "bg-[#f0f5ff]",
        border: "border-[#c6daff]",
      },
      {
        label: "Hiring",
        icon: <IconPeople className="size-[14px]" />,
        bg: "bg-[#ecf8f5]",
        border: "border-[#b6e9dc]",
      },
      {
        label: "Operations",
        icon: <IconAccountTree className="size-3" />,
        bg: "bg-[#feebfd]",
        border: "border-[#ffc1fd]",
      },
      {
        label: "Additional",
        icon: <IconAddCircle className="size-[14px]" />,
        bg: "bg-[#f0f5ff]",
        border: "border-[#c6daff]",
      },
    ],
  },
  {
    // Row 3 (Growth/Shipping/Advertising) — mobile 6147:28849 / desktop 6142:29446.
    animationClassName:
      "motion-safe:animate-[values-marquee_60s_linear_infinite]",
    className: "top-[111.33px] lg:top-[101.59px]",
    trackClassName: "gap-[16.535px] lg:gap-5",
    chips: [
      {
        label: "Growth",
        icon: <IconStackedBar className="size-4" />,
        bg: "bg-[#eafaee]",
        border: "border-[#abf0b7]",
      },
      {
        label: "Shipping",
        icon: <IconPeople className="size-[14px]" />,
        bg: "bg-[#ecf8f5]",
        border: "border-[#b6e9dc]",
      },
      {
        label: "Advertising",
        icon: <IconAdsClick className="size-4" />,
        bg: "bg-[#fef2f2]",
        border: "border-[#ffcdb5]",
      },
    ],
  },
];

const BENTO_SPEND_ROW_LAYOUT = [
  "max-xl:origin-top-right max-xl:top-[118px] max-xl:right-[-16px] max-xl:scale-[0.78] max-xl:gap-[14px] max-sm:top-[130px] max-sm:right-[-8px] max-sm:scale-[0.72] xl:origin-top-left xl:top-[41px] xl:right-auto xl:left-[320px] xl:scale-100 xl:gap-5",
  "max-xl:origin-top-right max-xl:top-[162px] max-xl:right-[-48px] max-xl:scale-[0.78] max-xl:gap-[14px] max-xl:opacity-90 max-sm:top-[174px] max-sm:scale-[0.72] xl:origin-top-left xl:top-[106px] xl:right-auto xl:left-[265px] xl:scale-100 xl:gap-[18px]",
  "max-xl:origin-top-right max-xl:top-[200px] max-xl:right-[-20px] max-xl:scale-[0.72] max-xl:gap-[14px] max-xl:opacity-20 max-sm:top-[212px] max-sm:scale-[0.65] xl:origin-top-left xl:top-[164px] xl:right-auto xl:left-[304px] xl:scale-100 xl:gap-5",
];

function SpendChip({ label, icon, bg, border }: SpendChipProps) {
  return (
    <div className="bg-grey-0 flex shrink-0 items-center gap-[7px] rounded-full py-2 pr-3.5 pl-2 shadow-[0px_4.8px_24px_rgba(0,0,0,0.06)]">
      <span
        className={cn(
          "flex size-[21px] shrink-0 items-center justify-center rounded-full border",
          bg,
          border
        )}
        aria-hidden
      >
        {icon}
      </span>
      <span className="text-grey-500 text-[16px] leading-[1.2] tracking-[-0.04em] whitespace-nowrap">
        {label}
      </span>
    </div>
  );
}

function SpendChipMarqueeRow({ row }: { row: SpendChipRow }) {
  const loop = [...row.chips, ...row.chips];

  return (
    <div
      className={cn(
        "absolute inset-x-0 overflow-hidden",
        row.className,
        row.mirror && "-scale-x-100"
      )}
    >
      <MarqueeTrack
        animationClassName={row.animationClassName}
        pauseOnHover={false}
        trackClassName={row.trackClassName}
      >
        {loop.map((chip, index) => (
          <li
            key={`${chip.label}-${index}`}
            aria-hidden={index >= row.chips.length}
            className={cn("shrink-0", row.mirror && "-scale-x-100")}
          >
            <SpendChip {...chip} />
          </li>
        ))}
      </MarqueeTrack>
    </div>
  );
}

/** Smooth vertical fade for chip rows — single grey hint, rows scroll above. */
function SpendChipsFade({
  children,
  fillContainer = false,
}: {
  children: ReactNode;
  fillContainer?: boolean;
}) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-x-0 bottom-0 overflow-hidden",
        fillContainer ? SPEND_CHIPS_FILL_CLASS : SPEND_CHIPS_AREA_CLASS
      )}
    >
      {/* One unified grey field — rows marquee on top (Figma 5948:28542). */}
      <span aria-hidden className="bg-grey-50 absolute inset-0" />
      {/* Soft blend into the card title above the chip zone. */}
      <span
        aria-hidden
        className="from-grey-0 pointer-events-none absolute inset-x-0 top-0 h-10 bg-gradient-to-b to-transparent"
      />
      {/* Chip rows — mask fades content top→bottom at the card edge. */}
      <div
        className="absolute inset-0"
        style={{
          maskImage:
            "linear-gradient(to bottom, black 0%, black 22%, rgba(0,0,0,0.95) 42%, rgba(0,0,0,0.78) 58%, rgba(0,0,0,0.52) 72%, rgba(0,0,0,0.26) 86%, rgba(0,0,0,0.08) 100%)",
          WebkitMaskImage:
            "linear-gradient(to bottom, black 0%, black 22%, rgba(0,0,0,0.95) 42%, rgba(0,0,0,0.78) 58%, rgba(0,0,0,0.52) 72%, rgba(0,0,0,0.26) 86%, rgba(0,0,0,0.08) 100%)",
        }}
      >
        {children}
      </div>
    </div>
  );
}

/** Spend category chip rows — used in the home Terms card and benefit bento cards. */
export function SpendChipsRows({
  variant = "card",
  fillContainer = false,
}: {
  variant?: "card" | "bento";
  /** When true, chip fade fills the parent (flex asset area below title). */
  fillContainer?: boolean;
}) {
  if (variant === "bento") {
    return (
      <>
        {SPEND_CHIP_ROWS.map((row, i) => (
          <div
            key={i}
            className={cn(
              "absolute flex w-max items-center",
              BENTO_SPEND_ROW_LAYOUT[i],
              row.trackClassName
            )}
            aria-hidden
          >
            {row.chips.map((chip) => (
              <SpendChip key={chip.label} {...chip} />
            ))}
          </div>
        ))}
      </>
    );
  }

  return (
    <SpendChipsFade fillContainer={fillContainer}>
      {SPEND_CHIP_ROWS.map((row, i) => (
        <SpendChipMarqueeRow key={i} row={row} />
      ))}
    </SpendChipsFade>
  );
}
